import { render, staticRenderFns } from "./AssetMgmt.vue?vue&type=template&id=6e97bc03&scoped=true&"
import script from "./AssetMgmt.vue?vue&type=script&lang=js&"
export * from "./AssetMgmt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e97bc03",
  null
  
)

export default component.exports